import(/* webpackMode: "eager" */ "D:\\Jenkins\\workspace\\ITDCS\\JCEW.CAMP\\ITDCS_JCEW.CAMP_HappyWed\\src\\app\\[lang]\\loading.tsx");
